/**
 * Blog data — 30 SEO-optimized articles for Nerava
 * Each article targets specific keywords for Indonesian online seller market
 */

const BLOG_IMAGES = {
  "Auto Reply & Chatbot": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/52de9463b443b4b2da3c9d9e5a0015dc41c51dd7315462c45cdd035775a8f93b.png",
  "Jualan Online & Closing": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/e0513972fa0c810369e6e046a40782eeb1643ea4caaab4426ee6759ce7e62507.png",
  "Manajemen Bisnis": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/690b07297be1948ae131ab0599245e0e6c9736ed8c7f95ab4a4e161bf1612334.png",
  "WhatsApp Business": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/52de9463b443b4b2da3c9d9e5a0015dc41c51dd7315462c45cdd035775a8f93b.png",
  "TikTok & Marketplace": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/690b07297be1948ae131ab0599245e0e6c9736ed8c7f95ab4a4e161bf1612334.png",
  "AI & Teknologi": "https://static.prod-images.emergentagent.com/jobs/9542a553-8509-42cf-8fd3-afe441894d98/images/43221ae320c02383fa48128eb4422f431a34bd3d7e790227a073e97604d280a8.png"
};

const blogArticles = [
  {
    id: 1,
    slug: "cara-auto-reply-whatsapp-toko-online",
    title: "Cara Membuat Auto Reply WhatsApp untuk Toko Online",
    category: "Auto Reply & Chatbot",
    excerpt: "Pelajari cara mengatur auto reply WhatsApp untuk toko online Anda agar bisa melayani customer 24 jam tanpa harus online terus.",
    readTime: "8 min",
    date: "2025-01-15",
    keywords: "auto reply whatsapp toko online, whatsapp auto reply jualan",
    content: `Sebagai pemilik toko online, salah satu tantangan terbesar adalah menjawab pesan customer yang masuk kapan saja — termasuk tengah malam. Auto reply WhatsApp adalah solusinya.

## Apa Itu Auto Reply WhatsApp?

Auto reply adalah fitur yang memungkinkan akun WhatsApp Anda membalas pesan secara otomatis tanpa harus mengetik manual. Untuk toko online, ini berarti customer tetap mendapat respons meskipun Anda sedang tidur.

## Metode Auto Reply WhatsApp

### 1. WhatsApp Business App (Gratis, Terbatas)
WhatsApp Business App menyediakan fitur "Away Message" dan "Quick Replies". Namun, fitur ini sangat terbatas — hanya bisa mengirim satu pesan template, tidak bisa menjawab pertanyaan spesifik tentang produk.

### 2. WhatsApp Business API + AI Chatbot (Rekomendasi)
Dengan WhatsApp Business API yang terhubung ke platform seperti Nerava, Anda bisa memiliki AI chatbot yang:
- Menjawab pertanyaan produk berdasarkan katalog
- Menghitung ongkos kirim otomatis
- Memproses pesanan dari chat
- Mengirim foto produk saat diminta
- Membalas dalam bahasa yang natural seperti manusia

### 3. WhatsApp Cloud API (Gratis dari Meta)
Meta menyediakan WhatsApp Cloud API secara gratis. Anda hanya perlu mendaftar di Meta Business Suite dan menghubungkan nomor WhatsApp Anda.

## Langkah Setup Auto Reply dengan Nerava

1. **Daftar** di nerava.id (gratis 30 hari)
2. **Hubungkan** nomor WhatsApp Business Anda
3. **Atur** katalog produk dan harga
4. **Aktifkan** AI Agent — selesai!

AI akan mulai menjawab pesan customer secara otomatis berdasarkan data produk Anda.

## Tips Agar Auto Reply Efektif

- **Pastikan data produk lengkap** — AI hanya bisa menjawab berdasarkan data yang tersedia
- **Gunakan gaya bahasa yang natural** — Customer tidak suka bicara dengan robot
- **Monitor percakapan** — Sesekali cek apakah AI menjawab dengan tepat
- **Siapkan eskalasi** — Jika pertanyaan terlalu kompleks, AI bisa meneruskan ke Anda

## Kesimpulan

Auto reply WhatsApp bukan lagi fitur mewah — ini kebutuhan dasar setiap toko online di era 2025. Dengan platform seperti Nerava, setup auto reply hanya butuh 10 menit dan langsung aktif 24/7.`
  },
  {
    id: 2,
    slug: "chatbot-ai-terbaik-umkm-indonesia",
    title: "5 Chatbot AI Terbaik untuk UMKM Indonesia 2025",
    category: "Auto Reply & Chatbot",
    excerpt: "Perbandingan 5 platform chatbot AI yang paling cocok untuk UMKM di Indonesia, dari yang gratis hingga berbayar.",
    readTime: "10 min",
    date: "2025-01-20",
    keywords: "chatbot ai umkm indonesia, chatbot terbaik umkm",
    content: `UMKM Indonesia semakin banyak yang mengadopsi chatbot AI untuk melayani customer. Tapi dengan banyaknya pilihan, mana yang paling cocok?

## 1. Nerava — AI Customer Service All-in-One

**Harga:** Mulai Rp 149.000/bulan (trial gratis 30 hari)

Nerava dirancang khusus untuk UMKM Indonesia. Kelebihannya:
- AI berbahasa Indonesia yang natural
- Multi-channel: WhatsApp, Instagram, Messenger, TikTok Shop
- Proses order otomatis dari chat
- Hitung ongkir dan kirim foto produk
- CRM dan analytics terintegrasi

**Cocok untuk:** Semua jenis toko online di Indonesia

## 2. WATI — WhatsApp Business Solution

**Harga:** Mulai $49/bulan

WATI fokus pada WhatsApp dengan fitur broadcast dan template message. Kekurangannya: hanya support WhatsApp, UI dalam bahasa Inggris.

## 3. SleekFlow — Omnichannel Platform

**Harga:** Mulai $79/bulan

SleekFlow menawarkan fitur omnichannel dan automation. Kekurangannya: harga mahal untuk UMKM, learning curve tinggi.

## 4. ManyChat — Chat Marketing

**Harga:** Gratis (terbatas) hingga $15/bulan

ManyChat bagus untuk Instagram dan Facebook automation. Kekurangannya: tidak support WhatsApp di Indonesia, fitur AI terbatas.

## 5. Kata.ai — Enterprise Chatbot

**Harga:** Custom (mulai jutaan/bulan)

Kata.ai adalah solusi enterprise dengan NLP bahasa Indonesia. Kekurangannya: terlalu mahal dan kompleks untuk UMKM.

## Perbandingan

| Fitur | Nerava | WATI | SleekFlow | ManyChat | Kata.ai |
|-------|--------|------|-----------|----------|---------|
| WhatsApp | Ya | Ya | Ya | Tidak | Ya |
| Instagram | Ya | Tidak | Ya | Ya | Tidak |
| AI Natural | Ya | Tidak | Terbatas | Terbatas | Ya |
| Bahasa Indonesia | Ya | Tidak | Tidak | Tidak | Ya |
| Harga UMKM | Ya | Mahal | Mahal | Murah | Sangat Mahal |

## Kesimpulan

Untuk UMKM Indonesia yang butuh solusi all-in-one dengan harga terjangkau, Nerava adalah pilihan terbaik. AI-nya memahami bahasa Indonesia, support multi-channel, dan proses order otomatis.`
  },
  {
    id: 3,
    slug: "auto-reply-instagram-dm-seller",
    title: "Auto Reply Instagram DM: Panduan Lengkap untuk Seller",
    category: "Auto Reply & Chatbot",
    excerpt: "Panduan step-by-step mengatur auto reply di Instagram DM untuk meningkatkan penjualan toko online Anda.",
    readTime: "7 min",
    date: "2025-01-25",
    keywords: "auto reply instagram dm, auto reply ig jualan",
    content: `Instagram DM adalah salah satu channel penjualan terbesar di Indonesia. Tapi bagaimana jika chat menumpuk dan Anda tidak sempat membalas satu per satu?

## Kenapa Auto Reply Instagram DM Penting?

- 73% customer mengharapkan respons dalam 1 jam
- Chat yang tidak dibalas = potensi penjualan hilang
- Seller yang respons cepat punya closing rate 3x lebih tinggi

## Cara Setup Auto Reply Instagram DM

### Cara 1: Instagram Professional Dashboard (Terbatas)
Instagram menyediakan fitur auto reply bawaan, tapi hanya bisa mengirim 1 template pesan. Tidak bisa menjawab pertanyaan spesifik.

### Cara 2: Platform AI seperti Nerava (Rekomendasi)
Dengan menghubungkan akun Instagram Business ke Nerava:
1. AI menjawab setiap DM berdasarkan katalog produk Anda
2. Customer bisa tanya harga, stok, ongkir — dijawab otomatis
3. Order bisa diproses langsung dari percakapan DM
4. Foto produk dikirim otomatis saat diminta

### Langkah Setup:
1. Pastikan akun Instagram Anda adalah **Professional Account** (Business/Creator)
2. Daftar di nerava.id
3. Di halaman Channels, klik **Connect Instagram**
4. Login Instagram dan berikan izin
5. Pilih AI Agent — selesai!

## Tips Auto Reply Instagram yang Efektif

- **Respons cepat** — Semakin cepat dibalas, semakin tinggi conversion
- **Personalisasi** — Gunakan nama customer di respons
- **Foto produk** — Sertakan foto saat customer bertanya tentang produk
- **CTA jelas** — Arahkan customer untuk order

## Kesimpulan

Auto reply Instagram DM bukan hanya menghemat waktu — tapi meningkatkan penjualan. Dengan AI yang natural, customer tidak akan merasa bicara dengan robot.`
  },
  {
    id: 4,
    slug: "balas-pesan-customer-otomatis-24-jam",
    title: "Cara Balas Pesan Customer Otomatis 24 Jam Tanpa Karyawan",
    category: "Auto Reply & Chatbot",
    excerpt: "Tidak perlu hire CS tambahan. AI chatbot bisa melayani customer toko online Anda 24/7 dengan biaya mulai Rp 149.000/bulan.",
    readTime: "6 min",
    date: "2025-02-01",
    keywords: "balas pesan otomatis 24 jam, cs otomatis toko online",
    content: `Hire karyawan CS = gaji jutaan per bulan. AI chatbot = Rp 149.000/bulan. Pilih mana?

## Realita Seller Online Indonesia

- Rata-rata seller menghabiskan 5-6 jam/hari hanya untuk balas chat
- Chat malam hari sering tidak terjawab = kehilangan order
- Hire CS = Rp 3-5 juta/bulan per orang

## Solusi: AI Customer Service

AI chatbot modern seperti Nerava bisa:
- Menjawab pertanyaan produk 24/7
- Memproses pesanan otomatis
- Menghitung ongkos kirim
- Mengirim foto produk
- Handle complaint dasar

Semua ini tanpa karyawan tambahan.

## Perbandingan Biaya

| Item | Karyawan CS | AI Chatbot (Nerava) |
|------|-------------|---------------------|
| Biaya/bulan | Rp 3-5 juta | Rp 149.000 |
| Jam kerja | 8 jam/hari | 24 jam/hari |
| Hari libur | Perlu backup | Tidak ada libur |
| Multi-channel | Sulit | Otomatis |
| Konsistensi | Bervariasi | Selalu konsisten |

## Cara Mulai

1. Daftar di nerava.id (gratis 30 hari)
2. Tambahkan produk ke katalog
3. Hubungkan WhatsApp/Instagram
4. AI langsung aktif melayani customer

## Kapan Tetap Butuh CS Manusia?

- Complaint kompleks yang butuh empati tinggi
- Negosiasi harga custom/wholesale
- Masalah teknis pengiriman

Untuk sisanya, AI sudah cukup.`
  },
  {
    id: 5,
    slug: "chatbot-rule-based-vs-ai",
    title: "Perbedaan Chatbot Rule-Based vs AI: Mana yang Cocok untuk Bisnis Anda?",
    category: "Auto Reply & Chatbot",
    excerpt: "Chatbot ada banyak jenisnya. Pahami perbedaan rule-based dan AI agar tidak salah pilih.",
    readTime: "7 min",
    date: "2025-02-05",
    keywords: "chatbot rule based vs ai, perbedaan chatbot",
    content: `Tidak semua chatbot diciptakan sama. Ada yang cerdas, ada yang kaku. Mana yang cocok untuk bisnis Anda?

## Chatbot Rule-Based

**Cara kerja:** Mengikuti aturan IF-THEN yang sudah ditentukan. Jika customer ketik "harga", bot jawab template harga.

**Kelebihan:**
- Setup mudah dan cepat
- Respons konsisten dan terprediksi
- Murah atau gratis

**Kekurangan:**
- Tidak bisa handle pertanyaan di luar aturan
- Terasa "kaku" dan tidak natural
- Perlu update manual setiap ada pertanyaan baru

**Contoh:** Auto reply bawaan WhatsApp Business

## Chatbot AI (Berbasis LLM)

**Cara kerja:** Menggunakan kecerdasan buatan untuk memahami konteks dan menjawab secara natural. Bisa handle pertanyaan yang tidak pernah diprogramkan sebelumnya.

**Kelebihan:**
- Percakapan natural seperti manusia
- Bisa handle pertanyaan tak terduga
- Belajar dari konteks katalog produk
- Bisa proses order, hitung ongkir, dll.

**Kekurangan:**
- Biaya lebih tinggi (tapi masih jauh lebih murah dari karyawan)
- Perlu monitoring sesekali

**Contoh:** Nerava AI, ChatGPT-powered bots

## Mana yang Cocok?

- **Bisnis baru, volume chat rendah (<20/hari):** Rule-based cukup
- **Bisnis growing, volume chat tinggi (>50/hari):** AI chatbot wajib
- **Bisnis multi-channel (WA + IG + TikTok):** AI chatbot dengan omnichannel

## Kesimpulan

Di tahun 2025, AI chatbot sudah sangat terjangkau untuk UMKM. Jika bisnis Anda serius ingin scale up, investasi di AI chatbot akan memberikan ROI yang jauh lebih besar daripada rule-based bot.`
  },
  {
    id: 6,
    slug: "auto-reply-facebook-messenger-jualan",
    title: "Cara Setup Auto Reply Facebook Messenger untuk Jualan Online",
    category: "Auto Reply & Chatbot",
    excerpt: "Facebook Messenger masih menjadi channel penting untuk jualan online. Pelajari cara setup auto reply yang efektif.",
    readTime: "6 min",
    date: "2025-02-10",
    keywords: "auto reply messenger jualan, auto reply facebook",
    content: `Meskipun banyak yang beralih ke WhatsApp dan Instagram, Facebook Messenger tetap penting — terutama untuk target market usia 30+.

## Setup Auto Reply Messenger di Nerava

1. Buka halaman **Channels** di dashboard Nerava
2. Klik **Connect** pada Facebook Messenger
3. Login Facebook dan pilih Page bisnis Anda
4. Pilih AI Agent — selesai!

Setiap pesan yang masuk ke Facebook Page Anda akan dijawab otomatis oleh AI.

## Tips Messenger untuk Jualan

- Gunakan Facebook Ads yang mengarah ke Messenger (Click to Message)
- AI akan handle pertanyaan dari iklan secara otomatis
- Conversion rate Messenger ads 3-5x lebih tinggi dari landing page

## Kesimpulan

Jangan abaikan Messenger. Dengan auto reply AI, Anda bisa memanfaatkan setiap pesan yang masuk tanpa effort tambahan.`
  },
  {
    id: 7,
    slug: "template-pesan-cs-toko-online",
    title: "10 Template Pesan CS yang Bikin Customer Langsung Closing",
    category: "Jualan Online & Closing",
    excerpt: "Kumpulan template pesan customer service yang terbukti meningkatkan closing rate toko online.",
    readTime: "8 min",
    date: "2025-02-15",
    keywords: "template pesan cs toko online, template chat jualan",
    content: `Kata-kata yang tepat bisa mengubah "Saya pikir-pikir dulu" menjadi "Oke, saya transfer sekarang."

## 1. Template Sapaan Pertama
"Halo kak! Selamat datang di [Nama Toko]. Ada yang bisa aku bantu hari ini?"

## 2. Template Jawab Pertanyaan Harga
"Untuk [Produk] harganya Rp [Harga] kak. Bahan [Detail], ready ukuran [Ukuran]. Mau order yang mana?"

## 3. Template Follow Up Belum Bayar
"Halo kak, pesanan [Produk] senilai Rp [Total] belum kami terima pembayarannya. Ada kendala? Kami siap bantu!"

## 4. Template Upsell
"Banyak customer yang beli [Produk A] juga ambil [Produk B] karena cocok dipadukan. Mau sekalian kak?"

## 5. Template Urgency
"Stok [Produk] tinggal [Jumlah] kak. Kalau mau, bisa langsung order sebelum kehabisan."

## 6. Template Konfirmasi Order
"Pesanan kak [Nama]: [Produk] x [Qty], total Rp [Total]. Alamat: [Alamat]. Sudah benar? Mau aku proses?"

## 7. Template Setelah Transfer
"Pembayaran diterima! Pesanan kak [Nama] sedang kami proses. Estimasi kirim hari ini/besok ya kak."

## 8. Template Handle Complaint
"Mohon maaf atas ketidaknyamanannya kak. Bisa kirim foto kondisi barangnya? Kami akan segera bantu."

## 9. Template Review Request
"Kak [Nama], pesanannya sudah sampai? Kalau berkenan, boleh kasih review ya kak. Terima kasih sudah belanja!"

## 10. Template Re-engagement
"Halo kak! Lama gak belanja nih. Kami ada produk baru lho, [Produk Baru] mulai Rp [Harga]. Mau lihat?"

## Pro Tips

Dengan platform seperti Nerava, semua template ini bisa diotomasi oleh AI. AI akan memilih template yang tepat berdasarkan konteks percakapan.`
  },
  {
    id: 8,
    slug: "meningkatkan-closing-rate-whatsapp",
    title: "Cara Meningkatkan Closing Rate dari Chat WhatsApp",
    category: "Jualan Online & Closing",
    excerpt: "7 strategi terbukti untuk mengubah chat WhatsApp menjadi penjualan.",
    readTime: "7 min",
    date: "2025-02-20",
    keywords: "meningkatkan closing rate whatsapp, closing dari chat",
    content: `Banyak chat masuk tapi sedikit yang jadi order? Ini strategi untuk meningkatkan closing rate.

## 1. Respons dalam 5 Menit
Data menunjukkan: seller yang respons dalam 5 menit punya closing rate 21x lebih tinggi. Gunakan auto reply untuk respons instan.

## 2. Kirim Foto Produk Real
Jangan hanya deskripsi teks. Kirim foto produk asli yang jelas dan menarik.

## 3. Sertakan Social Proof
"Produk ini best seller kak, sudah terjual 500+ pcs bulan ini."

## 4. Berikan Opsi, Bukan Pertanyaan Terbuka
Jangan: "Mau pesan apa kak?"
Lakukan: "Mau yang ukuran M atau L kak?"

## 5. Hitung Ongkir Langsung
Jangan suruh customer cek sendiri. Hitungkan langsung: "Ongkir ke Bandung Rp 14.000 via JNE REG, estimasi 2-3 hari."

## 6. Buat Urgency
"Promo ini berakhir hari ini ya kak" atau "Stok tinggal 3 pcs."

## 7. Follow Up yang Tepat
Jangan spam. Follow up 1x setelah 2-3 jam: "Kak, masih tertarik sama [Produk]? Ada yang bisa aku bantu?"

## Otomasi dengan AI

Semua strategi di atas bisa diotomasi oleh AI chatbot. AI Nerava sudah diprogram untuk:
- Respons instan 24/7
- Kirim foto otomatis
- Hitung ongkir langsung
- Follow up otomatis`
  },
  {
    id: 9,
    slug: "kesalahan-balas-chat-customer",
    title: "7 Kesalahan Fatal Saat Balas Chat Customer yang Bikin Gagal Closing",
    category: "Jualan Online & Closing",
    excerpt: "Hindari 7 kesalahan ini agar chat customer tidak berakhir dengan 'saya pikir-pikir dulu'.",
    readTime: "6 min",
    date: "2025-02-25",
    keywords: "kesalahan balas chat customer, gagal closing chat",
    content: `Sering dapat chat tapi jarang yang jadi order? Mungkin Anda melakukan salah satu dari kesalahan ini.

## 1. Terlambat Membalas
Customer chat jam 8 malam, Anda balas jam 8 pagi — customer sudah beli di tempat lain.

## 2. Jawaban Terlalu Singkat
Customer: "Ada ukuran L?"
Seller: "Ada"
— Ini bukan percakapan, ini interogasi.

## 3. Tidak Proaktif
Hanya menjawab pertanyaan tanpa mengarahkan ke order. Setelah jawab, tambahkan: "Mau order yang ini kak?"

## 4. Menyuruh Customer Cari Sendiri
"Cek ongkir di JNE ya kak" — Ini malas. Hitungkan langsung untuk customer.

## 5. Tidak Follow Up
Customer bilang "nanti ya" lalu Anda diam. Follow up setelah beberapa jam.

## 6. Terlalu Pushy
Terus-terusan desak customer untuk beli. Berikan informasi, bukan tekanan.

## 7. Tidak Konsisten
Pagi ramah, malam jutek karena capek. AI chatbot selalu konsisten 24/7.

## Solusi

Gunakan AI chatbot yang sudah diprogram untuk menghindari semua kesalahan di atas. AI Nerava menjawab cepat, proaktif, konsisten, dan tidak pernah capek.`
  },
  {
    id: 10,
    slug: "cara-follow-up-customer-belum-beli",
    title: "Cara Follow Up Customer yang Sudah Tanya Tapi Belum Beli",
    category: "Jualan Online & Closing",
    excerpt: "Teknik follow up yang tidak terasa spam tapi efektif mendorong customer untuk membeli.",
    readTime: "6 min",
    date: "2025-03-01",
    keywords: "cara follow up customer belum beli, follow up jualan online",
    content: `70% customer yang tanya produk tidak langsung beli. Tapi 35% dari mereka akan beli jika di-follow up dengan benar.

## Kapan Follow Up?

- **2-3 jam** setelah chat terakhir: "Kak, masih tertarik dengan [Produk]?"
- **1 hari** kemudian: "Halo kak! Produk [X] masih ready nih. Ada yang bisa dibantu?"
- **Jangan lebih dari 2x** follow up per customer — lebih dari itu terasa spam

## Penting: 24-Hour Window

Untuk WhatsApp dan Instagram, Anda hanya bisa mengirim pesan dalam 24 jam setelah pesan terakhir customer (Meta policy). Setelah itu, perlu template message (berbayar).

## Template Follow Up yang Efektif

**Casual:**
"Kak, kaos polos yang tadi masih tertarik? Stoknya tinggal dikit nih."

**Informatif:**
"Kak, mau kasih info — ongkir ke alamat kamu cuma Rp 14.000 lho. Total jadi Rp 84.000 aja."

**Bonus:**
"Kak, khusus hari ini kita kasih free packaging premium kalau order sekarang."

## Otomasi Follow Up

Platform Nerava punya fitur Auto Follow-Up yang:
- Kirim otomatis dalam 24 jam window (gratis, tidak ada biaya tambahan)
- 2 tipe: Belum Bayar dan Minat Belum Order
- AI personalisasi pesan berdasarkan konteks chat

Setup di **Pengaturan > Follow Up** di dashboard Nerava.`
  },
  {
    id: 11,
    slug: "strategi-chat-jadi-order",
    title: "Strategi Mengubah Chat Jadi Order: Dari Lead ke Closing",
    category: "Jualan Online & Closing",
    excerpt: "Panduan lengkap flow percakapan dari customer pertama kali chat hingga melakukan pembayaran.",
    readTime: "9 min",
    date: "2025-03-05",
    keywords: "strategi chat jadi order, lead ke closing",
    content: `Setiap chat yang masuk adalah potential revenue. Berikut flow optimal dari lead ke closing.

## Flow Percakapan Ideal

### Stage 1: Greeting (0-30 detik)
Customer: "Hai, ada kaos polos?"
Seller: "Hai kak! Ada, Kaos Polos Premium bahan katun. Mau lihat detailnya?"

### Stage 2: Product Info (1-3 menit)
- Kirim foto produk
- Jelaskan bahan, ukuran, warna
- Sebutkan harga langsung

### Stage 3: Qualify (3-5 menit)
- Tanya ukuran yang diinginkan
- Tanya jumlah
- Tanya alamat untuk ongkir

### Stage 4: Offer (5-7 menit)
- Hitungkan total (produk + ongkir)
- Berikan opsi kurir
- Sebutkan metode pembayaran

### Stage 5: Close (7-10 menit)
- Konfirmasi order
- Kirim detail pembayaran
- Minta konfirmasi dari customer

### Stage 6: After Sale
- Ucapkan terima kasih
- Kirim foto resi saat sudah dikirim
- Follow up setelah barang sampai

## Tips Penting

Seluruh flow di atas bisa diotomasi oleh AI. Nerava AI mengikuti exact flow ini — dari greeting hingga konfirmasi order. Rata-rata waktu dari chat pertama ke order: 8 menit.`
  },
  {
    id: 12,
    slug: "menangani-customer-minta-diskon",
    title: "Cara Menangani Customer yang Minta Diskon Terus",
    category: "Jualan Online & Closing",
    excerpt: "Strategi menghadapi customer yang selalu nego harga tanpa kehilangan mereka.",
    readTime: "5 min",
    date: "2025-03-10",
    keywords: "menangani customer minta diskon, nego harga jualan online",
    content: `"Kak, bisa kurang gak?" — Pertanyaan yang pasti familiar bagi setiap seller.

## Jangan Langsung Tolak atau Terima

Menolak mentah-mentah = kehilangan customer. Terima semua = profit menipis.

## Strategi yang Tepat

### 1. Redirect ke Value
"Harga segitu sudah termasuk packaging premium dan garansi 7 hari kak."

### 2. Tawarkan Bundle
"Untuk harga lebih hemat, bisa ambil 2 pcs kak. Jadi Rp [Harga Bundle]."

### 3. Berikan Benefit Lain
"Harga sudah pas kak, tapi khusus hari ini free ongkir ya!"

### 4. Jujur
"Maaf kak, harga sudah pas ya. Ini sudah harga terbaik untuk kualitas bahan premium."

## AI Nerava untuk Handle Nego

AI Nerava sudah diprogram untuk:
- Tidak memberikan diskon sembarangan
- Menolak klaim voucher/gift card palsu
- Redirect ke value proposition
- Harga hanya sesuai katalog

Ini mencegah kerugian dari "social engineering" oleh customer yang coba-coba minta diskon.`
  },
  {
    id: 13,
    slug: "kelola-chat-banyak-channel",
    title: "Cara Mengelola Chat Customer dari WhatsApp, IG, dan TikTok dalam 1 Dashboard",
    category: "Manajemen Bisnis",
    excerpt: "Buka-tutup 4 aplikasi untuk balas chat? Ada cara yang lebih efisien.",
    readTime: "7 min",
    date: "2025-03-15",
    keywords: "kelola chat banyak channel, omnichannel inbox",
    content: `Seller modern jualan di banyak platform. Tapi mengelola chat dari 4+ channel itu melelahkan.

## Masalah Multi-Channel

- Buka WhatsApp → balas chat → switch ke Instagram → balas DM → switch ke TikTok → balas buyer
- Chat terlewat karena terlalu banyak notifikasi
- Tidak tahu mana yang sudah dibalas, mana yang belum
- Data customer tersebar di mana-mana

## Solusi: Unified Inbox

Platform omnichannel seperti Nerava menggabungkan semua chat ke 1 dashboard:
- WhatsApp, Instagram DM, Facebook Messenger, TikTok Shop — semua di satu tempat
- Filter berdasarkan channel, status, atau priority
- AI auto-reply di semua channel sekaligus
- Data customer terpusat (CRM)

## Manfaat

1. **Hemat waktu** — Tidak perlu switch aplikasi
2. **Tidak ada yang terlewat** — Semua chat terlihat di satu tempat
3. **Konsisten** — AI menjawab dengan gaya yang sama di semua channel
4. **Analytics** — Lihat performa setiap channel dalam 1 dashboard`
  },
  {
    id: 14,
    slug: "omnichannel-toko-online",
    title: "Apa Itu Omnichannel dan Kenapa Toko Online Anda Butuh Ini",
    category: "Manajemen Bisnis",
    excerpt: "Omnichannel bukan cuma buzzword. Ini strategi yang terbukti meningkatkan penjualan dan kepuasan customer.",
    readTime: "8 min",
    date: "2025-03-20",
    keywords: "omnichannel toko online, apa itu omnichannel",
    content: `Omnichannel = semua channel komunikasi bisnis Anda terintegrasi dalam satu sistem.

## Multichannel vs Omnichannel

**Multichannel:** Punya WhatsApp, IG, TikTok — tapi masing-masing berdiri sendiri.
**Omnichannel:** Semua channel terhubung. Customer chat di IG, dilanjutkan di WA — data percakapan tetap terjaga.

## Kenapa UMKM Butuh Omnichannel?

1. Customer Anda ada di mana-mana (WA, IG, TikTok, FB)
2. Mereka bisa mulai chat di IG, lanjut di WA
3. Tanpa omnichannel, Anda harus tanya ulang dari awal di setiap channel
4. Dengan omnichannel, semua histori tersimpan di 1 tempat

## Implementasi Omnichannel untuk UMKM

Tidak perlu sistem mahal. Platform seperti Nerava menyediakan:
- Unified inbox untuk semua channel
- CRM yang otomatis mengumpulkan data customer
- AI yang konsisten di semua channel
- Analytics per channel

Mulai dari Rp 149.000/bulan.`
  },
  {
    id: 15,
    slug: "crm-untuk-umkm",
    title: "CRM untuk UMKM: Panduan Lengkap Mengelola Data Pelanggan",
    category: "Manajemen Bisnis",
    excerpt: "CRM bukan cuma untuk perusahaan besar. UMKM pun perlu mengelola data pelanggan dengan rapi.",
    readTime: "8 min",
    date: "2025-03-25",
    keywords: "crm untuk umkm, crm toko online",
    content: `CRM (Customer Relationship Management) = sistem untuk mengelola hubungan dengan pelanggan.

## Kenapa UMKM Butuh CRM?

- Tahu siapa customer terbaik Anda (yang sering beli)
- Tahu kapan terakhir customer belanja
- Bisa follow up customer yang sudah lama tidak beli
- Data tidak hilang meskipun ganti HP

## CRM Sederhana untuk UMKM

Tidak perlu Salesforce atau HubSpot yang mahal. CRM di Nerava sudah mencakup:

### Data yang Tercatat Otomatis:
- Nama customer
- Nomor HP dan email
- Channel asal (WA/IG/TikTok)
- Riwayat pembelian
- Total belanja
- Terakhir chat/order

### Yang Bisa Anda Lakukan:
- Filter customer berdasarkan total belanja
- Lihat customer yang sudah lama tidak order
- Export data ke Excel
- Segmentasi untuk promo target

## Tips CRM untuk Seller

1. **Selalu minta nama dan HP** — Data dasar yang wajib
2. **Catat preferensi** — "Customer A suka ukuran L"
3. **Follow up repeat customer** — Lebih murah daripada cari customer baru
4. **Manfaatkan data untuk promo** — Kirim promo yang relevan`
  },
  {
    id: 16,
    slug: "hitung-ongkir-otomatis-dari-chat",
    title: "Cara Menghitung Ongkir Otomatis dari Chat Customer",
    category: "Manajemen Bisnis",
    excerpt: "Jangan suruh customer cek ongkir sendiri. Hitungkan langsung dari percakapan — otomatis.",
    readTime: "5 min",
    date: "2025-04-01",
    keywords: "hitung ongkir otomatis chat, ongkir dari percakapan",
    content: `"Cek ongkir di JNE ya kak" — Kalimat ini membunuh conversion rate Anda.

## Kenapa Harus Hitung Ongkir Otomatis?

Setiap langkah tambahan yang harus dilakukan customer = berkurang kemungkinan mereka jadi beli. Jika customer harus keluar dari chat untuk cek ongkir, ada kemungkinan besar mereka tidak kembali.

## Cara Kerja di Nerava

1. Customer kirim alamat di chat
2. AI otomatis mendeteksi kota/kecamatan dari alamat
3. Sistem menghitung ongkir ke beberapa kurir (JNE, J&T, SiCepat, dll.)
4. AI menampilkan opsi ongkir langsung di chat:
   "Ongkir ke Bandung:
   - JNE REG: Rp 14.000 (2-3 hari)
   - JNE YES: Rp 18.000 (1 hari)
   - J&T EZ: Rp 12.000 (2-3 hari)
   Mau pakai yang mana kak?"

Customer tinggal pilih — tidak perlu buka aplikasi lain.

## Integrasi Ekspedisi

Nerava terintegrasi dengan RajaOngkir/Komerce yang mencakup 20+ kurir di Indonesia. Harga ongkir selalu update dan akurat.`
  },
  {
    id: 17,
    slug: "tools-seller-online-indonesia",
    title: "5 Tools Wajib untuk Seller Online di Indonesia 2025",
    category: "Manajemen Bisnis",
    excerpt: "Rekomendasi tools yang akan menghemat waktu dan meningkatkan efisiensi toko online Anda.",
    readTime: "7 min",
    date: "2025-04-05",
    keywords: "tools seller online indonesia, tools jualan online",
    content: `Jualan online di 2025 butuh tools yang tepat. Berikut 5 yang wajib dimiliki.

## 1. Platform Customer Service AI (Nerava)
Untuk auto reply chat, proses order, dan kelola customer dari semua channel.

## 2. Canva — Desain Konten
Untuk membuat foto produk, banner promo, dan konten sosmed.

## 3. Google Sheets / Excel — Rekap Keuangan
Untuk mencatat pemasukan dan pengeluaran harian.

## 4. CapCut — Edit Video
Untuk membuat video produk yang menarik di TikTok dan Instagram Reels.

## 5. Tokopedia/Shopee Seller Center — Marketplace
Untuk mengelola toko di marketplace.

## Bonus: Integrasi Antar Tools

Platform seperti Nerava bisa mengintegrasikan beberapa tools sekaligus — misalnya order dari chat otomatis tercatat di sistem, customer data tersimpan di CRM, dan ongkir dihitung otomatis dari kurir partner.`
  },
  {
    id: 18,
    slug: "invoice-otomatis-dari-chat",
    title: "Cara Membuat Invoice Otomatis dari Percakapan Chat",
    category: "Manajemen Bisnis",
    excerpt: "Order masuk dari chat? Invoice langsung tergenerate otomatis dan dikirim ke email customer.",
    readTime: "5 min",
    date: "2025-04-10",
    keywords: "buat invoice otomatis dari chat, invoice toko online",
    content: `Buat invoice manual itu makan waktu. Apalagi kalau order ratusan per bulan.

## Invoice Otomatis di Nerava

Setiap kali AI mengkonfirmasi pesanan, sistem otomatis:
1. Generate invoice dengan nomor unik
2. Isi data customer, produk, harga, ongkir
3. Hitung total dan pajak (jika ada)
4. Kirim ke email customer
5. Update status saat pembayaran diterima

## Manfaat

- Tidak ada human error dalam penulisan nominal
- Customer terlihat profesional menerima invoice formal
- Rekap keuangan otomatis terdata
- Mudah tracking pembayaran`
  },
  {
    id: 19,
    slug: "whatsapp-business-api-vs-app",
    title: "WhatsApp Business API vs WhatsApp Business App: Apa Bedanya?",
    category: "WhatsApp Business",
    excerpt: "Banyak yang bingung antara WA Business biasa dan WA Business API. Ini penjelasan lengkapnya.",
    readTime: "8 min",
    date: "2025-04-15",
    keywords: "whatsapp business api vs app, perbedaan wa business",
    content: `WhatsApp untuk bisnis ada 2 versi: App dan API. Keduanya sangat berbeda.

## WhatsApp Business App (Gratis)

**Cocok untuk:** Bisnis kecil dengan 1-2 orang yang handle chat

- Download gratis di Play Store/App Store
- 1 nomor = 1 device (bisa multi-device tapi terbatas)
- Fitur: katalog produk, quick replies, away message, label
- Tidak bisa diintegrasikan dengan platform lain
- Tidak ada API access

## WhatsApp Business API

**Cocok untuk:** Bisnis yang serius scale up

- Perlu provider/partner (atau langsung via Meta Cloud API)
- Multi-agent: banyak orang bisa akses 1 nomor
- Integrasi dengan CRM, chatbot AI, dll.
- Broadcast ke ribuan customer sekaligus
- Template message untuk komunikasi di luar 24 jam window
- Analytics dan reporting detail

## Mana yang Harus Dipilih?

| Kriteria | WA Business App | WA Business API |
|----------|-----------------|-----------------|
| Chat < 50/hari | Cukup | Overkill |
| Chat > 100/hari | Kewalahan | Ideal |
| Multi-agent | Tidak bisa | Bisa |
| Chatbot AI | Tidak bisa | Bisa |
| Broadcast massal | Terbatas | Ribuan sekaligus |
| Harga | Gratis | Mulai Rp 149.000/bulan via Nerava |

## Setup WA Business API via Nerava

1. Daftar di nerava.id
2. Di halaman Channels, pilih WhatsApp
3. Pilih "Cloud API" — ikuti proses Meta Embedded Signup
4. Nomor WA Anda langsung terhubung ke dashboard

Proses hanya 5 menit.`
  },
  {
    id: 20,
    slug: "centang-hijau-whatsapp-business",
    title: "Cara Mendapatkan Centang Hijau WhatsApp Business",
    category: "WhatsApp Business",
    excerpt: "Centang hijau = kepercayaan customer. Begini cara mendapatkannya.",
    readTime: "6 min",
    date: "2025-04-20",
    keywords: "centang hijau whatsapp business, verified badge wa",
    content: `Centang hijau di WhatsApp Business menunjukkan bahwa akun bisnis Anda sudah diverifikasi oleh Meta. Ini meningkatkan kepercayaan customer.

## Syarat Mendapatkan Centang Hijau

1. Gunakan WhatsApp Business API (bukan App biasa)
2. Bisnis Anda harus terverifikasi di Meta Business Suite
3. Pastikan nama bisnis konsisten di semua platform
4. Bisnis harus legal dan comply dengan kebijakan Meta

## Langkah-langkah

1. Daftar Meta Business Suite (business.facebook.com)
2. Verifikasi bisnis Anda (upload dokumen legal)
3. Hubungkan nomor WhatsApp via Cloud API
4. Ajukan centang hijau melalui Meta Business Suite
5. Tunggu review (biasanya 1-4 minggu)

## Tips Agar Diapprove

- Pastikan bisnis Anda punya online presence (website, sosmed aktif)
- Gunakan nama bisnis resmi (sesuai NIB/SIUP)
- Pastikan nomor WA sudah aktif dan memiliki display name yang jelas`
  },
  {
    id: 21,
    slug: "whatsapp-cloud-api-pemula",
    title: "Panduan WhatsApp Cloud API untuk Pemula",
    category: "WhatsApp Business",
    excerpt: "WhatsApp Cloud API gratis dari Meta. Pelajari cara menggunakannya untuk bisnis Anda.",
    readTime: "9 min",
    date: "2025-04-25",
    keywords: "whatsapp cloud api pemula, panduan wa cloud api",
    content: `WhatsApp Cloud API adalah cara gratis untuk mengakses WhatsApp Business API tanpa melalui BSP (Business Solution Provider) pihak ketiga.

## Apa Bedanya dengan BSP?

- **BSP (WATI, Twilio, dll.):** Bayar ke mereka, mereka yang manage API
- **Cloud API (langsung dari Meta):** Gratis, Anda langsung connect ke Meta

## Kelebihan Cloud API

- Gratis (hanya bayar per percakapan ke Meta, harga sangat murah)
- Setup langsung di Meta Business Suite
- Tidak perlu server sendiri untuk hosting WhatsApp
- Selalu update ke versi terbaru

## Cara Setup

### Via Nerava (Paling Mudah):
1. Daftar nerava.id
2. Pilih "WhatsApp Cloud API" di halaman Channels
3. Login Meta → pilih nomor → selesai!

Nerava handle semua kompleksitas teknis (webhook, token management, message routing).

## Biaya

- Cloud API sendiri: Gratis
- Per percakapan: ~Rp 300-600 per customer-initiated, ~Rp 700-1.500 per business-initiated
- Via Nerava: Rp 149.000/bulan (sudah termasuk AI, CRM, multi-channel)`
  },
  {
    id: 22,
    slug: "broadcast-whatsapp-tanpa-banned",
    title: "Cara Broadcast WhatsApp Tanpa Kena Banned",
    category: "WhatsApp Business",
    excerpt: "Broadcast ke ribuan customer sekaligus tanpa risiko nomor diblokir. Begini caranya.",
    readTime: "7 min",
    date: "2025-05-01",
    keywords: "broadcast whatsapp tanpa banned, wa blast aman",
    content: `Broadcast WhatsApp bisa jadi senjata marketing yang powerful — tapi juga bisa membuat nomor Anda di-banned jika dilakukan salah.

## Kenapa Bisa Kena Banned?

- Kirim pesan ke nomor yang tidak menyimpan kontak Anda
- Terlalu banyak pesan dalam waktu singkat
- Konten spam atau promosi agresif
- Banyak yang report nomor Anda

## Cara Broadcast yang Aman

### 1. Gunakan WhatsApp Business API
JANGAN broadcast dari WhatsApp biasa. Gunakan API resmi.

### 2. Gunakan Template Message yang Diapprove
Meta mengharuskan pesan broadcast menggunakan template yang sudah diapprove. Ini menjamin konten tidak spam.

### 3. Target yang Tepat
Kirim hanya ke customer yang pernah berinteraksi. Jangan blast ke nomor random.

### 4. Berikan Opt-Out
Sertakan opsi "Balas STOP untuk berhenti menerima pesan."

### 5. Gradual Sending
Jangan kirim ke 10.000 nomor sekaligus. Kirim bertahap: 100/jam, evaluasi, lalu naikkan.

## Template Broadcast yang Efektif

"Halo {nama}! Ada produk baru di toko kami: [Produk] mulai Rp [Harga]. Mau lihat? Balas 'INFO' untuk detail. Balas 'STOP' untuk unsubscribe."

## Fitur Broadcast di Nerava (Coming Soon)

Nerava sedang mengembangkan fitur broadcast WhatsApp yang:
- Comply dengan kebijakan Meta
- Template message approval otomatis
- Scheduling dan gradual sending
- Analytics (open rate, reply rate)`
  },
  {
    id: 23,
    slug: "hubungkan-whatsapp-ke-website",
    title: "Cara Menghubungkan WhatsApp ke Website Toko Online",
    category: "WhatsApp Business",
    excerpt: "Tambahkan tombol WhatsApp di website agar visitor langsung bisa chat dengan toko Anda.",
    readTime: "5 min",
    date: "2025-05-05",
    keywords: "hubungkan whatsapp ke website, tombol wa di website",
    content: `Pengunjung website Anda butuh cara mudah untuk menghubungi toko. Tombol WhatsApp adalah jawabannya.

## Cara Paling Simpel

Tambahkan link wa.me di website:
https://wa.me/6285111444413?text=Halo, saya mau tanya tentang produk

## Cara Lebih Profesional: Chat Widget

Platform seperti Nerava menyediakan chat widget yang bisa dipasang di website. Fiturnya:
- Tombol floating di pojok kanan bawah
- Customer bisa langsung chat tanpa keluar website
- Chat masuk ke dashboard Nerava (bersama WA, IG, dll.)
- AI bisa auto-reply langsung

## Setup Chat Widget Nerava

1. Di dashboard Nerava, buka **Channels**
2. Klik **Website Chat Widget**
3. Copy kode embed
4. Paste di website Anda (sebelum tag </body>)
5. Selesai!`
  },
  {
    id: 24,
    slug: "response-rate-tiktok-shop",
    title: "Cara Meningkatkan Chat Response Rate di TikTok Shop",
    category: "TikTok & Marketplace",
    excerpt: "Response rate mempengaruhi ranking toko di TikTok Shop. Begini cara meningkatkannya.",
    readTime: "6 min",
    date: "2025-05-10",
    keywords: "response rate tiktok shop, meningkatkan response tiktok",
    content: `TikTok Shop mengukur response rate seller. Jika rendah, ranking toko Anda bisa turun.

## Apa Itu Response Rate?

Persentase chat buyer yang dijawab dalam waktu yang ditentukan (biasanya 24 jam). Target ideal: >90%.

## Tantangan

- Buyer TikTok Shop sering chat di luar jam kerja
- Volume chat meningkat drastis saat live selling
- Chat menumpuk dari berbagai produk sekaligus

## Solusi: AI Auto-Reply

Dengan mengintegrasikan TikTok Shop ke platform AI seperti Nerava:
- Setiap chat buyer dijawab otomatis dalam hitungan detik
- Response rate mendekati 100%
- AI menjawab pertanyaan produk berdasarkan katalog
- Buyer mendapat pengalaman belanja yang responsif

## Cara Integrasi

1. Daftar di nerava.id
2. Hubungkan TikTok Shop di halaman Channels
3. AI langsung aktif menjawab chat buyer`
  },
  {
    id: 25,
    slug: "customer-service-tiktok-shop",
    title: "Tips Customer Service TikTok Shop yang Bikin Repeat Order",
    category: "TikTok & Marketplace",
    excerpt: "Customer service yang baik di TikTok Shop membuat buyer kembali lagi. Ini tipsnya.",
    readTime: "6 min",
    date: "2025-05-15",
    keywords: "customer service tiktok shop, cs tiktok jualan",
    content: `Di TikTok Shop, persaingan ketat. Yang membedakan adalah customer service.

## Tips CS TikTok Shop

### 1. Respons Cepat
Buyer TikTok Shop punya attention span pendek. Jika tidak direspons cepat, mereka beli di toko lain.

### 2. Jawab dengan Detail
Jangan cuma "Ada kak." Berikan detail: ukuran, bahan, estimasi pengiriman.

### 3. Kirim Foto/Video Real
Buyer lebih percaya foto real daripada foto studio.

### 4. Handle Complaint dengan Baik
Buyer yang complaint lalu ditangani dengan baik justru sering jadi loyal customer.

### 5. Follow Up
"Kak, barangnya sudah sampai? Kalau ada masalah, kabari ya."

## Otomasi CS TikTok Shop

Semua tips di atas bisa diotomasi oleh AI chatbot. Platform Nerava sudah mendukung integrasi TikTok Shop Customer Service API.`
  },
  {
    id: 26,
    slug: "jualan-multi-platform",
    title: "Cara Jualan di Multi-Platform: Shopee, Tokopedia, TikTok Shop Sekaligus",
    category: "TikTok & Marketplace",
    excerpt: "Jualan di banyak platform berarti lebih banyak exposure. Tapi bagaimana mengelolanya?",
    readTime: "7 min",
    date: "2025-05-20",
    keywords: "jualan multi platform, jualan di shopee tokopedia tiktok",
    content: `Semakin banyak platform, semakin besar peluang penjualan. Tapi juga semakin besar tantangan.

## Tantangan Multi-Platform

- Chat menumpuk dari semua platform
- Stok harus di-sync manual
- Data customer tersebar
- Waktu habis untuk hal administratif

## Solusi

### 1. Gunakan Platform Omnichannel
Platform seperti Nerava menggabungkan chat dari WhatsApp, Instagram, Messenger, dan TikTok Shop dalam 1 inbox.

### 2. Standarisasi Proses
- Template respons yang sama di semua platform
- SOP yang jelas untuk order processing
- AI chatbot untuk konsistensi

### 3. Prioritaskan Channel dengan ROI Tertinggi
Tidak perlu perfect di semua platform. Fokus pada 2-3 platform yang memberikan penjualan terbanyak.

## Tips

Mulai dari 1 platform, kuasai, baru expand. Jangan langsung 5 platform sekaligus — Anda akan kewalahan.`
  },
  {
    id: 27,
    slug: "ai-customer-service-cara-kerja",
    title: "Apa Itu AI Customer Service dan Bagaimana Cara Kerjanya",
    category: "AI & Teknologi",
    excerpt: "AI customer service bukan science fiction. Ini teknologi nyata yang sudah digunakan UMKM Indonesia.",
    readTime: "8 min",
    date: "2025-05-25",
    keywords: "ai customer service cara kerja, apa itu ai cs",
    content: `AI customer service adalah sistem yang menggunakan kecerdasan buatan untuk melayani customer secara otomatis.

## Bagaimana Cara Kerjanya?

### 1. Natural Language Processing (NLP)
AI membaca pesan customer dan memahami maksudnya. "Ada kaos hitam ukuran L gak?" → AI mengerti: customer ingin produk kaos, warna hitam, ukuran L.

### 2. Context Understanding
AI tahu konteks percakapan. Jika customer sudah menyebut produk di pesan sebelumnya, AI tidak akan tanya ulang.

### 3. Knowledge Base
AI mengakses data produk, harga, stok, dan informasi toko untuk menjawab pertanyaan.

### 4. Response Generation
AI menghasilkan jawaban yang natural dan relevan — bukan template kaku.

## Apa yang Bisa Dilakukan AI CS?

- Menjawab pertanyaan produk (harga, stok, varian)
- Mengirim foto produk
- Menghitung ongkos kirim
- Memproses pesanan
- Handle keluhan dasar
- Follow up customer

## Apa yang Tidak Bisa Dilakukan AI CS?

- Negosiasi kompleks
- Handle complaint yang butuh empati tinggi
- Keputusan bisnis strategis
- Masalah yang memerlukan judgment manusia

## Biaya

Dengan teknologi seperti Google Gemini yang semakin murah, AI customer service sekarang terjangkau untuk UMKM. Platform Nerava menawarkan AI CS mulai Rp 149.000/bulan.`
  },
  {
    id: 28,
    slug: "ai-membantu-umkm",
    title: "5 Cara AI Membantu UMKM Menghemat Waktu dan Biaya",
    category: "AI & Teknologi",
    excerpt: "AI bukan pengganti manusia. AI adalah asisten yang membuat UMKM lebih efisien.",
    readTime: "6 min",
    date: "2025-06-01",
    keywords: "ai membantu umkm, ai untuk bisnis kecil",
    content: `AI mengubah cara UMKM beroperasi. Bukan dengan menggantikan manusia, tapi dengan mengotomasi tugas repetitif.

## 1. Auto Reply Customer Chat — Hemat 5 Jam/Hari
AI menjawab pertanyaan customer 24/7. Seller tidak perlu lagi duduk depan HP seharian.

## 2. Proses Order Otomatis — Hemat 2 Jam/Hari
Dari chat ke order tercatat — tanpa input manual. Nama, alamat, produk, harga — semua otomatis.

## 3. Hitung Ongkir Otomatis — Hemat 30 Menit/Pesanan
Tidak perlu buka aplikasi kurir, input alamat, bandingkan harga. AI hitung langsung di chat.

## 4. CRM Otomatis — Hemat 1 Jam/Hari
Data customer otomatis tercatat. Tidak perlu catat manual di spreadsheet.

## 5. Follow Up Otomatis — Hemat 1 Jam/Hari
AI kirim reminder ke customer yang belum bayar atau belum order. Tanpa Anda harus ingat satu per satu.

## Total Penghematan: ~9 Jam/Hari

Dengan biaya hanya Rp 149.000/bulan, itu setara Rp 3.300/jam — jauh lebih murah dari karyawan.`
  },
  {
    id: 29,
    slug: "masa-depan-customer-service-ai",
    title: "Masa Depan Customer Service: Kenapa AI Akan Menggantikan CS Manual",
    category: "AI & Teknologi",
    excerpt: "Dalam 5 tahun ke depan, 80% customer service akan ditangani AI. Bisnis Anda sudah siap?",
    readTime: "7 min",
    date: "2025-06-05",
    keywords: "masa depan customer service ai, tren cs 2025",
    content: `Tahun 2020, chatbot masih kaku. Tahun 2025, AI sudah bisa percakapan natural. Tahun 2030?

## Tren AI Customer Service

### 2025: AI Text-Based
AI bisa menjawab pertanyaan produk, proses order, dan handle complaint basic via teks.

### 2026-2027: AI Multimodal
AI bisa memproses gambar (identifikasi produk dari foto), voice message, dan video. Customer kirim foto → AI langsung identifikasi produk.

### 2028-2030: AI Proaktif
AI tidak hanya menjawab — tapi proaktif. AI tahu customer A suka beli setiap bulan, dan kirim rekomendasi sebelum ditanya.

## Kenapa UMKM Harus Adopt Sekarang?

1. **First mover advantage** — Bisnis yang adopt AI duluan punya pengalaman lebih
2. **Customer expectation** — Customer sudah terbiasa dengan respons cepat
3. **Biaya turun** — Harga AI semakin murah setiap tahun
4. **Kompetisi** — Kompetitor Anda mungkin sudah pakai AI

## Mulai dari Mana?

Coba AI customer service gratis 30 hari di nerava.id. Tanpa kartu kredit, tanpa commitment.`
  },
  {
    id: 30,
    slug: "studi-kasus-ai-chatbot-penjualan",
    title: "Studi Kasus: Bagaimana Toko Online Meningkatkan Penjualan 3x Lipat dengan AI Chatbot",
    category: "AI & Teknologi",
    excerpt: "Kisah nyata toko online yang berhasil meningkatkan penjualan setelah menggunakan AI chatbot.",
    readTime: "8 min",
    date: "2025-06-10",
    keywords: "studi kasus ai chatbot penjualan, ai meningkatkan penjualan",
    content: `Toko kaos online "Urban Polos" di Bandung menghadapi masalah klasik: chat banyak, closing sedikit.

## Sebelum AI Chatbot

- 100+ chat/hari dari WhatsApp dan Instagram
- Hanya 1 orang yang handle semua chat
- Response time rata-rata: 2-3 jam
- Closing rate: 15%
- Revenue: Rp 15 juta/bulan

## Masalah Utama

1. Chat malam hari tidak terjawab (40% chat masuk jam 8 malam - 12 malam)
2. Customer sering tanya hal yang sama berulang (harga, ukuran, ongkir)
3. Follow up tidak konsisten
4. Data customer berantakan

## Implementasi AI (Nerava)

Proses setup: 30 menit
- Upload 15 produk ke katalog
- Hubungkan WhatsApp dan Instagram
- Set AI Agent dengan gaya bahasa friendly

## Setelah 1 Bulan

- Response time: 3 detik (dari 2-3 jam!)
- Closing rate: 35% (naik dari 15%)
- Chat malam terjawab 100%
- Revenue: Rp 45 juta/bulan

## Setelah 3 Bulan

- Revenue: Rp 55 juta/bulan
- Customer retention naik 40%
- Owner bisa fokus ke marketing dan product development
- Hire 1 CS untuk handle complaint kompleks (bukan rutin)

## Kunci Sukses

1. **AI handle 80% pertanyaan rutin** — Harga, stok, ongkir, proses order
2. **Manusia handle 20% yang kompleks** — Complaint, wholesale, custom order
3. **Data customer terpusat** — Semua tercatat di CRM
4. **Follow up otomatis** — Customer yang belum bayar diingatkan otomatis

## ROI

- Investasi: Rp 149.000/bulan (paket Starter)
- Peningkatan revenue: Rp 30 juta/bulan
- ROI: 303x

*Catatan: Angka dalam studi kasus ini adalah simulasi berdasarkan data rata-rata UMKM Indonesia yang menggunakan AI customer service.*`
  }
];

export { BLOG_IMAGES };
export default blogArticles;
